import React from 'react';
import GridCell from './GridCell';

const GridRow = (props) => {
  return (
    <tr className="base-tr">
      {props.columns.map((col, index) => <GridCell column={col} row={props.row} key={index} />)}
    </tr>
  );
};

export default GridRow;



// WEBPACK FOOTER //
// ./src/common/core/grid/GridRow.jsx